import { SignIn } from '@clerk/react';

/**
 * Hosted sign-in page. Used as the canonical sign-in URL Clerk redirects
 * to when an authenticated route is hit signed-out. The modal sign-in in
 * the topbar still works for users who explicitly click "Sign in"; this
 * page is the destination for forced redirects.
 *
 * It also consumes organization-invitation tickets for invitees whose email
 * ALREADY has a Clerk account: Clerk sends them here with `__clerk_ticket`
 * and `__clerk_status=sign_in`, and <SignIn> ties the accepted invitation to
 * their existing account on completion. `forceRedirectUrl="/staff"` then lands
 * them on the dashboard (mirrors the sign-up path), where the newly-created
 * org membership takes over.
 */
export default function SignInPage() {
  return (
    <div className="auth-page">
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl="/sign-up"
        forceRedirectUrl="/staff"
      />
    </div>
  );
}
